import * as keyboardjs from 'keyboardjs';
import {ArgValidator} from "./ArgValidator";

export class KeyboardUtils {
    public static bindKeyRelease(keyCombo: string | string[], released: keyboardjs.Callback) {
        ArgValidator.ensureIsNotNullOrUndefined(released, 'released');

        KeyboardUtils.bind(keyCombo, null, released);
    }

    public static bindKeyPress(keyCombo: string | string[], pressed: keyboardjs.Callback) {
        ArgValidator.ensureIsNotNullOrUndefined(pressed, 'pressed');

        KeyboardUtils.bind(keyCombo, pressed);
    }

    public static bind(keyCombo: string | string[], pressed: keyboardjs.Callback, released?: keyboardjs.Callback) {
        ArgValidator.ensureIsNotNullOrUndefined(keyCombo, 'keyCombo');

        keyboardjs.bind(keyCombo, pressed, released);
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Utils/KeyboardUtils.ts
 **/